import React, { useEffect, useRef, useState } from "react";

const SVGAAnimation = ({ src, className, width, height }) => {
  const canvasRef = useRef(null);
  const playerRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  // Load SVGA script dynamically
  useEffect(() => {
    if (typeof window.SVGA === "undefined") {
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/svgaplayerweb@2.3.1/build/svga.min.js";
      script.async = true;
      script.onload = () => setIsLoaded(true);
      document.body.appendChild(script);
    } else {
      setIsLoaded(true);
    }
  }, []);

  // Initialize player when script loads
  useEffect(() => {
    if (!isLoaded) return;

    const player = new window.SVGA.Player(canvasRef.current);
    const parser = new window.SVGA.Parser();

    // Configure player for smooth playback
    player.loops = 0; // Play once (0 = infinite)
    player.clearsAfterStop = true;

    parser.load(src, (videoItem) => {
      player.setVideoItem(videoItem);
      player.startAnimation();
    });

    playerRef.current = player;

    return () => {
      player.clear(); // Proper cleanup
    };
  }, [src, isLoaded]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      height={height}
      width={width}
    />
  );
};

export default SVGAAnimation;
